












































































































import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import InputGeneric from '@/components/InputGeneric.vue'
import { Company, CompanyManager } from '@/utils/Interfaces'
import { round } from '@/utils/CommonUtils'

@Component({
  components: {
    InputGeneric,
  }
})
export default class NhapLieuCtyTTChung extends Vue {
  @Prop() readonly company!: Company
  @Prop(Array) readonly managers!: Array<CompanyManager>

  show = true

  ty_le_von_gop: number | null = null

  @Watch('company.von_dieu_le')
  onVonDieuLeChange (val: number) {
    this.ty_le_von_gop = this.calculateTyLeVonGop(undefined, val)
  }

  @Watch('ty_le_von_gop')
  onTyLeVonGopChange (ty_le: number) {
    if (isNaN(ty_le) || this.company.von_dieu_le === null || isNaN(this.company.von_dieu_le)) return

    this.company.von_dieu_le_tong_cong_ty = round(ty_le * this.company.von_dieu_le)
    this.company.von_dieu_le_don_vi = this.company.von_dieu_le - this.company.von_dieu_le_tong_cong_ty
  }

  calculateTyLeVonGop (von_dieu_le_tong_cong_ty?: number | null, von_dieu_le?: number | null): number | null {
    if (von_dieu_le_tong_cong_ty === undefined) von_dieu_le_tong_cong_ty = this.company.von_dieu_le_tong_cong_ty
    if (von_dieu_le === undefined) von_dieu_le = this.company.von_dieu_le

    if (von_dieu_le_tong_cong_ty !== null && von_dieu_le !== null) {
      return von_dieu_le_tong_cong_ty / von_dieu_le
    }
    else {
      return null
    }
  }

  @Emit('add-manager')
  addManager () { return }

  @Emit('remove-manager')
  removeManager (index: number) { return index }
}
